module.exports = __webpack_public_path__ + "img/mingbai1.5_5d2eccc5d.png";